import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'app/services';
import { isEmpty } from 'lodash';
import { environment } from 'environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-virtual-tour-code',
  templateUrl: './virtual-tour-code.component.html',
  styleUrls: ['./virtual-tour-code.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VirtualTourCodeComponent implements OnInit {

  apiKey: any;
  id: any;
  public html = '' as string;

  constructor(
    public dialogRef: MatDialogRef<VirtualTourCodeComponent>,
    private _snackBar: MatSnackBar,
    private _translateService: TranslateService,
    private _authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public _data: any,
  ) {
    if (!isEmpty(this._data)) {
      this.id = this._data._id;
    }
    this.apiKey = this._authenticationService.currentUserValue.user_apikey;
  }

  ngOnInit(): void {
    // tslint:disable-next-line: max-line-length
    this.html += `<iframe width="100%" height="600" src="${environment.frontendUrl}index.php?r=virtualtours/index&user_apikey=${this.apiKey}&id=${this.id}" allowfullscreen></iframe>`;
  }

  copyLink(): void {
    this._snackBar.open(this._translateService.instant('Copied successfully'), this._translateService.instant('Close'), {
      duration: 2000,
    });
  }

}
